import React from 'react';
import {formatPrice, interpolate} from "@/utils";
import {ChargesType, CmsPageContentIdentifier, CmsPageContentType} from "@/types/av-check";

export interface PriceCondAfterProps {
    nextCharges: string[],
    cms: CmsPageContentType,
    charges: ChargesType,
    isAvCheckResultsDisplay?: boolean,
    chargesNature?: string,
    technologyPricingDiscountLabel?: string,
    technologyPricingSurchargeLabel?: string,
    technologyPricingVariationHintLabel?: string,
    isDtagFtthTariff?: boolean,
    setShowPdpActivationCostInfo?: (showPdpActivationCostInfo:boolean)=>void,
    setShowPdpDevelopmentCostInfo?: (showPdpDevelopmentCostInfo:boolean)=>void,
    displayPriceTextList: string[]
}
const infoIconColor = {color: "#0090d0"};
export const PriceCondAfter: React.FC<PriceCondAfterProps> =
    ({
         nextCharges,
         cms,
         charges,
         isAvCheckResultsDisplay,
         chargesNature,
         technologyPricingVariationHintLabel,
         isDtagFtthTariff,
         setShowPdpActivationCostInfo,
         setShowPdpDevelopmentCostInfo,
        displayPriceTextList
     }) => (
        <>
            {nextCharges.map((nc, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <React.Fragment key={index}>
                    {nc}
                    <br />
                </React.Fragment>
            ))}
            <>
                {chargesNature?.includes("TECHNOLOGY_PRICING") && (
                    <>
                        {technologyPricingVariationHintLabel}
                        <br />
                    </>)}
            </>
            <>
                {displayPriceTextList.length > 0 && displayPriceTextList.map((displayText, index) => (
                    <>
                        { displayText != '' &&
                        <React.Fragment key={index}>
                            <span dangerouslySetInnerHTML={{ __html: displayText}} />
                        </React.Fragment>
                        }
                    </>

                    ))
                }
            </>
            <>
                {!isAvCheckResultsDisplay && (
                    <>

                        {(!charges.priceCategoryWithRanks && charges.nonRecurringCosts > 0)
                        && (
                            <>
                                {`+ einmalig ${formatPrice(charges.nonRecurringCosts)}`}
                                <br />
                            </>
                        )}
                        {charges.activationFee > 0 &&
                        (<>
                            {isDtagFtthTariff ? `+ einmaliger Anschlusspreis ${formatPrice(charges.activationFee)}` : `+ Anschlusspreis ${formatPrice(charges.activationFee)}`}
                            { isDtagFtthTariff && <a
                                className="modal-link info"
                                onClick={setShowPdpActivationCostInfo && (() => setShowPdpActivationCostInfo(true))}
                                style={infoIconColor}
                            />}
                            <br />
                        </>)}

                        {charges.priceCategoryWithRanks && charges.priceCategoryWithRanks.filter(price => price.value >= 0).map((nc, index) => (
                            <>
                                    {nc.category === 'DEVELOPMENT_COST_CHARGE' &&
                                    (
                                        <>
                                            <p style={{fontWeight : 'normal', margin: '0 0 1px'}}>
                                                { interpolate(cms[CmsPageContentIdentifier.TechnologyPricingDevelopmentCharge],
                                                    {price: formatPrice(nc.value), from: isDtagFtthTariff ? "ab " : ""})}
                                                { isDtagFtthTariff && <a
                                                    className="modal-link info"
                                                    onClick={setShowPdpDevelopmentCostInfo && (() => setShowPdpDevelopmentCostInfo(true))}
                                                    style={infoIconColor}
                                                />}
                                            </p>
                                            <br/>
                                        </>
                                    ) }
                                {nc.category === 'INFRASTRUCTURE_FEE_CHARGE' && ( <>{interpolate(cms[CmsPageContentIdentifier.TechnologyPricingInfrastructureCharge],
                                    {price: formatPrice(nc.value)})}<br /></>) }
                            </>
                        ))}

                        {charges.priceCategoryWithRanks && charges.priceCategoryWithRanks.filter(price => price.value <= 0).map((nc, index) => (
                            <>
                                {nc.category === 'DEVELOPMENT_COST_DISCOUNT' && ( <>{interpolate(cms[CmsPageContentIdentifier.TechnologyPricingDevelopmentDisount],
                                    {price: formatPrice(Math.abs(nc.value))})}<br /></>) }
                                {nc.category === 'ACTIVATION_FEE_DISCOUNT' && ( <>{interpolate(cms[CmsPageContentIdentifier.TechnologyPricingConnectionDiscount],
                                    {price: formatPrice(Math.abs(nc.value))})}<br /></>) }
                            </>
                        ))}

                    </>)}
            </>
        </>
    );

export default PriceCondAfter;
